import React, { Children } from 'react';
import { Crumb } from '.';
import { TypedElements } from '../../../util/types.util';

interface BreadcrumbsProps {
  children: TypedElements<typeof Crumb>;
}

export default function Breadcrumbs({ children }: BreadcrumbsProps) {
  const crumbs = Children.toArray(children);

  return (
    <nav className='content-x flex w-full gap-2 border-b border-gray-default py-4 text-sm'>
      {crumbs.map((crumb, index) => {
        return (
          <React.Fragment key={index}>
            {index > 0 && <div>/</div>}
            {crumb}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
